import React, { useEffect } from 'react';
import StartTrackingButton from '../../../components/sharedComponents/StartTrackingButton';
import styles from '../styles/tryFree.module.css';
import useMediaQuery from '../../../hooks/useMediaQuery';



const Hero = ({ showCheckout, mediaUrl }) => {

    const isAboveMediumScreens = useMediaQuery("(min-width: 500px)");
    const backGroundImage = mediaUrl + '/images/kidsTrackingBig.webp';

    useEffect(() => {
        const onInit = () => {
            localStorage.setItem("freeTrial", true);
        };
        onInit();
    }, [])

    return (
        <section>
            <div className={styles.heroBgImage} style={{ backgroundImage: `url(${backGroundImage})` }}>
                <div className={styles.homeHeroInnerContainer}>
                    <div className='maxScreen'>
                        {!isAboveMediumScreens && <div className={styles.emptyContainer}></div>}
                        <div className={styles.heroContainer}>
                            <div className={styles.bannerContainer}>
                                <div className={styles.banner}><p className={styles.bannerTitle}>7-DAY FREE TRIAL</p></div>
                            </div>
                            <h1 className={styles.heading}><span className="hightLightText">Stay connected</span>
                                <br></br>with the world’s #1<br></br> device tracking app.</h1>
                            {isAboveMediumScreens ? < p className={styles.paragraph}>
                                See live locations, get automatic arrival alerts and peace of mind, all for free for 7 days.
                            </p> : null}
                            <br />
                            <br />
                            <StartTrackingButton title="Start Your Free 7-Day Trial" style={styles.startTrackingButton} onButtonClick={showCheckout} />

                        </div>
                        <div className={styles.emptyContainer}></div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default Hero;